import { initialState } from "./state"

export default {
  reset: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },
  setQuestionsList: (state, questions) => (state.questionsList = questions),
  addSavedQuestionUuid: (state, questions) =>
    state.savedQuestionsUuid.push(questions),
  removeSavedQuestionUuid: (state, uuid) =>
    (state.savedQuestionsUuid = state.savedQuestionsUuid.filter(q => q != uuid))
}
